import { useMemo } from "react";
import { bindActionCreators } from "@reduxjs/toolkit";
import { jwtActions } from "redux/actions";
import { useAppDispatch, useAppSelector } from "redux/store";

export const useJwt = () => {
  const state = useAppSelector((state) => state.jwtReducer);
  const dispatch = useAppDispatch();
  const actions = useMemo(
    () => bindActionCreators(jwtActions, dispatch),
    [dispatch]
  );

  return { state, actions };
};
